import { motion } from "framer-motion";
import { pc } from "../lib/api";
import { useT } from "../lib/i18n";

const R = 52, C = 2 * Math.PI * R;

export default function LoadRing({ week, members = [], meId }) {
  const t = useT();
  const total = week?.total || 0;
  let acc = 0;
  const slices = (week?.slices || []).map((s) => {
    const len = total ? (s.count / total) * C : 0;
    const seg = { ...s, len, doneLen: s.count ? (len * (s.done || 0)) / s.count : 0, off: acc, colorHex: s.admin ? "#FF6FA3" : pc(s.color).fill };
    acc += len;
    return seg;
  });
  const isAdminView = (week?.slices || []).some((s) => s.admin && s.id === meId);
  const center = isAdminView ? week.admin_pct : week?.my_pct;
  const last = week?.last_admin_pct;
  return (
    <div data-testid="load-ring-card" className="ul-card p-4 flex items-center gap-4">
      <svg width="132" height="132" viewBox="0 0 132 132" className="shrink-0">
        <circle cx="66" cy="66" r={R} fill="none" stroke="#F1EEFB" strokeWidth="16" />
        {slices.map((s) => (
          <g key={s.id}>
            <motion.circle cx="66" cy="66" r={R} fill="none" stroke={s.colorHex} strokeOpacity={0.35} strokeWidth="16"
              transform="rotate(-90 66 66)" initial={false}
              animate={{ strokeDasharray: `${Math.max(s.len - 2, 0)} ${C}`, strokeDashoffset: -s.off }} transition={{ duration: 0.9, ease: "easeInOut" }} />
            <motion.circle cx="66" cy="66" r={R} fill="none" stroke={s.colorHex} strokeWidth="16"
              transform="rotate(-90 66 66)" initial={false}
              animate={{ strokeDasharray: `${Math.max(Math.min(s.doneLen, s.len - 2), 0)} ${C}`, strokeDashoffset: -s.off }} transition={{ duration: 0.9, ease: "easeInOut" }} />
          </g>
        ))}
        <text x="66" y="68" textAnchor="middle" className="font-display" style={{ fontSize: 28, fontWeight: 800, fill: "#2A2540" }} data-testid="load-ring-pct">{center ?? 0}%</text>
        <text x="66" y="86" textAnchor="middle" style={{ fontSize: 10, fontWeight: 800, fill: "#6B6680", letterSpacing: 1.2 }}>{t("YOURS")}</text>
      </svg>
      <div className="min-w-0">
        <p className="ul-label">{t("Your load ring")}</p>
        {isAdminView && last != null ? (
          <p className="font-display font-bold text-lg leading-tight mt-1" data-testid="load-ring-trend">
            {center < last ? t("Down from {n}% last week 🌿", { n: last }) : center > last ? t("Up from {n}% last week. Let's share more 💜", { n: last }) : t("Same as last week")}
          </p>
        ) : (
          <p className="font-display font-bold text-lg leading-tight mt-1">{t("{n} things this week", { n: total })}</p>
        )}
        {isAdminView && week?.starting_share != null && <p className="text-xs text-[#6B6680]">{t("You started at {n}%", { n: week.starting_share })}</p>}
        <p className="text-xs text-[#6B6680]" data-testid="load-ring-done">{t("{d} of {t} done this week · solid = done", { d: week?.done ?? 0, t: total })}</p>
        <div className="flex flex-wrap gap-x-3 gap-y-1 mt-2">
          {slices.map((s) => (
            <span key={s.id} className="text-xs font-bold flex items-center gap-1" style={{ color: "#6B6680" }}>
              <i className="w-2.5 h-2.5 rounded-full inline-block" style={{ background: s.colorHex }} />{s.name} {s.pct}%
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
